import { Router} from '@angular/router';

import {Component, OnInit} from '@angular/core';
import {PermissionService} from '../../../_services/permission.service';
import {ProjectService} from '../../../_services';
import {SidebarPermissionsModel} from '../../../_models/sidebar-permissions.model';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./template-components-style.scss']
})
export class SidebarComponent implements OnInit {
    // public hidden = true;
    public user;
    public permissions = new SidebarPermissionsModel();
    public hidden = false;
    public ishovered = false;

    public logoUrl = environment.logoUrl;
    public mainColor: string;
    public agencyName = null;

    constructor(
        public router: Router,
        private permissionService: PermissionService,
        private projectService: ProjectService
    ) {
        this.mainColor = environment.agencyName === "Hotelis" ? "#033768" : "#16a085";
    }

    ngOnInit() {
        this.user = JSON.parse(localStorage.getItem('currentUser'));
        this.permissionService.sidebarPermissions().subscribe(response => {
          this.permissions = response;
        });

        this.hidden = localStorage.getItem('sidebar') !== null;

        // JS-1802: show which agency (pool) this session is working in
        if (this.user && this.user.agency_id && this.user.role !== 'employee') {
            this.projectService.getAgencyLogoPath(this.user.agency_id).subscribe(response => {
                this.agencyName = response.agency_name;
            });
        }
    }

    // showHideSidebar() {
    //     if (this.hidden) {
    //         document.body.className = '';
    //         this.hidden = false;
    //     } else {
    //         document.body.className = 'aside-hidden';
    //         this.hidden = true;
    //     }
    // }

    hoverOnSidebar() {
        document.body.className = 'aside-open';
        this.hidden = false;
        // localStorage.setItem('sidebar', 'open');
        this.ishovered = true;
    }

    hoverOutSidebar() {
        if(this.ishovered === true) {
            document.body.className = 'aside-hidden';
            // localStorage.removeItem('sidebar')
            this.ishovered = false;
        }
    }

    // showHideSidebar() {
    //     if (this.hidden) {
    //         document.body.className = 'aside-open';
    //         this.hidden = false;
    //         localStorage.setItem('sidebar', 'open');
    //     } else {
    //         document.body.className = 'aside-hidden';
    //         this.hidden = true;
    //         localStorage.removeItem('sidebar')
    //     }
    // }

    isRouteActive(name: string) {
        return this.router.url.split('/', 2)[1].substr(0, name.length) === name;
    }

    // JS-1872: active state for the hover-submenu links (matches on full route prefix).
    isSubrouteActive(path: string) {
        return this.router.url.startsWith(path);
    }

    // JS-1901 (Bleona 22 Oct / Musa 23 Oct): the flyout stays where it is and paints above the
    // .opensticky toggle arrow. While an open flyout covers the arrow's spot, the arrow itself
    // moves just below the flyout (above it near the bottom of the screen) and comes back when
    // the pointer leaves the item. Bound as [style.top.px] on .opensticky; null = the CSS position.
    public arrowTop: number | null = null;

    moveArrowClearOfFlyout(item: HTMLElement) {
        const aside = item.closest('.aside-bar');
        const arrow = aside ? aside.querySelector('.opensticky') as HTMLElement : null;
        const menu = item.querySelector('.sidebar-submenu') as HTMLElement;
        if (!arrow || !menu) {
            return;
        }
        const a = arrow.getBoundingClientRect();
        let top = menu.getBoundingClientRect().top;
        let bottom = menu.getBoundingClientRect().bottom;
        if (bottom <= top) {
            // :hover has not laid the flyout out yet - estimate from the row and its link count
            top = item.getBoundingClientRect().top;
            bottom = top + Math.max(1, menu.children.length) * 34;
        }
        if (!(top < a.bottom && bottom > a.top)) {
            this.arrowTop = null;
            return;
        }
        const gap = 8;
        const belowFits = bottom + gap + a.height <= window.innerHeight;
        const edge = belowFits ? bottom + gap : top - gap - a.height;
        // .opensticky is translateY(-50%), so its top is the wanted edge plus half its height
        this.arrowTop = Math.round(edge + a.height / 2);
    }

    resetArrow() {
        this.arrowTop = null;
    }
}
